import { InjectionToken } from '@angular/core';

export const MAIS_API_BASE_URL = new InjectionToken<string>('MAIS_API_BASE_URL', {
  factory: () => ''
});
